import { render, staticRenderFns } from "./LayoutAuthorized.vue?vue&type=template&id=33141ffe&"
import script from "./LayoutAuthorized.vue?vue&type=script&lang=js&"
export * from "./LayoutAuthorized.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports